import * as React from "react";
import Card, { Recommendation, CardType, ClickEvent } from "./Card";

export interface TBSRecommendationProps extends TBSRecommendation {
	click: ClickEvent;
	cardNumber: number;
}

export interface TBSRecommendation extends Recommendation {
	chapterName: string;
	problemName: string;
	problemId: string | number;
	positiveReviewCount: number;
	problemSnippet?: string;
	solutionSnippet?: string;
	solutionURL: string;
	isbn13: number;
}

const CSHPTBSCard = (props: TBSRecommendationProps) => {
	const data: CardType = {
		title: `Chapter ${props.chapterName}, Solution ${props.problemName}`,
		textPrefix: props.problemSnippet ? "Q: " : "A: ",
		text: props.problemSnippet || props.solutionSnippet,
		imageURL: props.imageURL,
		thumbnailURL: props.thumbnailURL,
		positiveReviewsCount: props.positiveReviewCount,
		link: props.solutionURL,
		linkText: "See solution",
		id: props.problemId,
		cardNumber: props.cardNumber,
		cardClickHandler: props.click,
	};
	return <Card data={data} />;
};

CSHPTBSCard.displayName = "CSHPTBSCard";
export default CSHPTBSCard;
